// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SklanskyChubukovRouteImport } from './routes/sklansky-chubukov'
import { Route as SixmaxOpeningRouteImport } from './routes/sixmax-opening'
import { Route as PreflopEquityRouteImport } from './routes/preflop-equity'
import { Route as MixedStrategyRouteImport } from './routes/mixed-strategy'
import { Route as EightmaxOpeningRouteImport } from './routes/eightmax-opening'
import { Route as CustomChartRouteImport } from './routes/custom-chart'
import { Route as CombosRouteImport } from './routes/combos'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'

const SklanskyChubukovRoute = SklanskyChubukovRouteImport.update({
            id: '/sklansky-chubukov',path: '/sklansky-chubukov',getParentRoute: () => rootRouteImport
          })
const SixmaxOpeningRoute = SixmaxOpeningRouteImport.update({
            id: '/sixmax-opening',path: '/sixmax-opening',getParentRoute: () => rootRouteImport
          })
const PreflopEquityRoute = PreflopEquityRouteImport.update({
            id: '/preflop-equity',path: '/preflop-equity',getParentRoute: () => rootRouteImport
          })
const MixedStrategyRoute = MixedStrategyRouteImport.update({
            id: '/mixed-strategy',path: '/mixed-strategy',getParentRoute: () => rootRouteImport
          })
const EightmaxOpeningRoute = EightmaxOpeningRouteImport.update({
            id: '/eightmax-opening',path: '/eightmax-opening',getParentRoute: () => rootRouteImport
          })
const CustomChartRoute = CustomChartRouteImport.update({
            id: '/custom-chart',path: '/custom-chart',getParentRoute: () => rootRouteImport
          })
const CombosRoute = CombosRouteImport.update({
            id: '/combos',path: '/combos',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,CombosRoute: CombosRoute,CustomChartRoute: CustomChartRoute,EightmaxOpeningRoute: EightmaxOpeningRoute,MixedStrategyRoute: MixedStrategyRoute,PreflopEquityRoute: PreflopEquityRoute,SixmaxOpeningRoute: SixmaxOpeningRoute,SklanskyChubukovRoute: SklanskyChubukovRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)